(() => {
  'use strict';
  const config = document.getElementById('maya-form-translations');
  if (!config) return;
  const decode=text=>{const box=document.createElement('textarea');box.innerHTML=text;return box.value;};
  const entries = JSON.parse(config.textContent).map(e => ({...e,text:decode(e.text).replace(/\[\[MAYA_PLACEHOLDER_(\d+)\]\]/g,(_,n)=>e.tokens[n])}));
  const normalize = text => text.replace(/\s+/g,' ').trim();
  const exact = new Map(entries.filter(e=>e.source).map(e=>[normalize(e.source),e.text]));
  const translate = value => {
    if(typeof value!=='string')return value;
    const normalized=normalize(value);
    const translated=exact.get(normalized);
    if(translated)return translated;
    const zone='Eastern Time - Toronto, ON';
    if(normalized.startsWith(zone+' (UTC'))return value.replace(zone,exact.get(zone) || zone);
    return value;
  };
  // All fields below are display-only app settings. Never change IDs, submitted option values, service IDs or integrations.
  function patchGloboForm(form) {
    if(!form || typeof form!=='object')return;
    const patch=(object,keys)=>{if(object)for(const k of keys)if(typeof object[k]==='string')object[k]=translateHTML(object[k]);};
    patch(form.header,['title','description']);
    if(typeof form.html==='string')form.html=translateHTML(form.html);
    for(const element of form.elements || [])patch(element,['label','placeholder','description']);
    patch(form.footer,['previousText','nextText','submitText','resetButtonText']);
    patch(form.afterSubmit,['message']);
    patch(form.accountPage,['title','headerDescription','message','updateText']);
    patch(form.publish,['requiredLoginMessage']);
    patch(form.integration?.shopify,['messageRedirectToLogin']);
    if(form.errorMessage)for(const k of Object.keys(form.errorMessage))form.errorMessage[k]=translate(form.errorMessage[k]);
  }
  function translateHTML(html) {
    const translated=translate(html);if(translated!==html)return translated;
    if(typeof html!=='string'||!html.includes('<'))return html;
    const template=document.createElement('template');template.innerHTML=html;
    translateTree(template.content);return template.innerHTML;
  }
  function patchApps() {
    const booking=window.Tipo?.Booking;
    if(booking?.settings?.translation?.widget){
      const translated={...(booking.trans || booking.settings.translation.widget.default)};
      for(const e of entries)if(e.tipoKey)translated[e.tipoKey]=e.text;
      const locale=document.documentElement.lang || booking.locale || 'en';
      booking.settings.translation.widget[locale]=translated;
      booking.trans=translated;
      const translation=booking.settings.translation;
      for(const key of ['customDatePickerDays','customDatePickerDaysMin','customDatePickerDaysShort','customDatePickerMonths','customDatePickerMonthsShort']){
        if(translated[key])translation[key]=translated[key];
      }
      const calendar=booking.settings.languageDatepicker;
      if(calendar)for(const [key,label] of Object.entries({days:'customDatePickerDays',daysMin:'customDatePickerDaysMin',daysShort:'customDatePickerDaysShort',months:'customDatePickerMonths',monthsShort:'customDatePickerMonthsShort'})){
        if(translated[label])calendar[key]=translated[label].split(',').map(s=>s.trim());
      }
      for(const field of Object.values(booking.settings.free_form || {}))if(typeof field.label==='string')field.label=translate(field.label);
      if(locale.toLowerCase().startsWith('fr') && booking.settings.general?.formatDate==='MMM,DD YYYY')booking.settings.general.formatDate='YYYY-MM-DD';
      // Keep the stored booking date format and timezone unchanged.
      translation.languageDatepicker=locale;
    }
    const forms=window.Globo?.FormBuilder?.forms;
    if(forms)for(const form of Object.values(forms)){
      if(form?.elements)patchGloboForm(form);else if(form && typeof form==='object')for(const item of Object.values(form))patchGloboForm(item);
    }
  }
  const roots='.globo-formbuilder,.globo-form-modal-content,#tpb-widget-popup,[tpb-modal],[class^="tpb-"],[id^="tpb-"],[data-layout-type="form"],[data-layout-type="list"]';
  const calendarEnglish=new Set(entries.filter(e=>e.source && /^(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sun|Mon|Tue|Wed|Thu|Fri|Sat|Su|Mo|Tu|We|Th|Fr|Sa|January|February|March|April|May|June|July|August|September|October|November|December|Jan|Feb|Mar|Apr|Jun|Jul|Aug|Sep|Oct|Nov|Dec)$/.test(e.source)).map(e=>e.source));
  function translateTree(root,scoped=false){
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    let node;
    while((node=walker.nextNode())){
      const parent=node.parentElement;
      if(parent?.closest('script,style,textarea,input,code,pre,[contenteditable=true],[data-maya-user-content]'))continue;
      const value=normalize(node.nodeValue);
      if(!value)continue;
      if(scoped && calendarEnglish.has(value) && !parent?.closest('[class*=calendar],[class*=datepicker],[class*=date-picker]'))continue;
      const translated=translate(value);
      if(translated && translated!==value)node.nodeValue=node.nodeValue.replace(node.nodeValue.trim(),translated);
    }
    root.querySelectorAll?.('[placeholder],[aria-label],[title],input[type=submit],input[type=button]').forEach(el=>{
      for(const attr of ['placeholder','aria-label','title'])if(el.hasAttribute(attr)){
        const value=el.getAttribute(attr),translated=translate(value);if(translated!==value)el.setAttribute(attr,translated);
      }
      if(el.matches('input[type=submit],input[type=button]')){const next=translate(el.value);if(next!==el.value)el.value=next;}
    });
  }
  // This deferred script is deliberately declared before the apps' deferred assets, so globals are localized before initialization.
  patchApps();
  const queue=new Set();let scheduled=false;
  function enqueue(root){
    if(!root)return;queue.add(root);
    if(!scheduled){scheduled=true;queueMicrotask(()=>{scheduled=false;for(const node of queue)if(node.isConnected)translateTree(node,true);queue.clear();setDefaultPhoneCountry();});}
  }
  function setDefaultPhoneCountry(){
    const phone=document.querySelector('.tpb__form-module__input[name="phone_number"]');
    const instance=phone && window.intlTelInputGlobals?.getInstance?.(phone);
    if(instance && !phone.value && instance.getSelectedCountryData?.().iso2==='af')instance.setCountry('ca');
  }
  document.querySelectorAll(roots).forEach(enqueue);
  const observer=new MutationObserver(records=>{
    for(const record of records){
      const el=record.target.nodeType===Node.ELEMENT_NODE?record.target:record.target.parentElement;
      const parent=el?.closest?.(roots);if(parent)enqueue(parent);
      for(const node of record.addedNodes){if(node.nodeType!==Node.ELEMENT_NODE)continue;if(node.matches(roots))enqueue(node);node.querySelectorAll(roots).forEach(enqueue);}
    }
  });
  observer.observe(document.documentElement,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['placeholder','aria-label','title']});
  document.addEventListener('DOMContentLoaded',()=>{patchApps();document.querySelectorAll(roots).forEach(enqueue);setDefaultPhoneCountry();},{once:true});
  window.GalerieMayaForms={patchApps,translateHTML,entries};
})();
